module.exports = __webpack_public_path__ + "img/portfolio-post_off.69c6f26d.png";